import { createReducer } from '@reduxjs/toolkit';
import {
  QUERYING_SURVEY_AI,
  QUERY_SURVEY_AI_SUCCEEDED,
  QUERY_SURVEY_AI_FAILED
} from './actions';

const initialState = {
  querying: false,
  lastResponse: null,
  error: null
};

export default createReducer(initialState, {
  [QUERYING_SURVEY_AI]: state => {
    state.querying = true;
    state.error = null;
    return state;
  },
  [QUERY_SURVEY_AI_SUCCEEDED]: (state, action) => {
    state.querying = false;
    state.lastResponse = action.payload;
    state.error = null;
    return state;
  },
  [QUERY_SURVEY_AI_FAILED]: (state, action) => {
    state.querying = false;
    state.error = action.payload;
    return state;
  }
});
